import { getAssessableTypesState } from './../../../shared/shared.select'
import {
  FetchAssessableTypesRequest,
  SetDefaultData,
} from './../../../shared/shared.actions'
import {
  getWardDetectionState,
  getDiscountGroupsState,
} from '@shared/shared.select'
import { NgxPermissionsService } from 'ngx-permissions'
import {
  getSearchStreetsState,
  getSearchCommunitiesState,
  getSearchWardsState,
  isWardDetectionLoading,
} from '@shared/shared.select'
import {
  SearchStreetsRequest,
  SearchCommunitiesRequest,
  SearchWardsRequest,
  DetectWardByCoordinateRequest,
  FetchDiscountGroupsRequest,
} from '@shared/shared.actions'
import {
  getPropertyState,
  getCreatePropertyState,
} from './../properties.selectors'
import { Map, List } from 'immutable'
import {
  FetchPropertyBusinessesRequest,
  UpdateField,
} from './../properties.actions'
import { Router, ActivatedRoute } from '@angular/router'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from '@traits/form.trait'
import { Store, select } from '@ngrx/store'
import { Subscription, Subject, Observable } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import { Ward } from '@containers/wards/wards.interface'
import { isContentEditableEnabled } from '@containers/i18n/store/i18n.selector'

@Component({
  selector: 'app-property-details',
  templateUrl: './property-details.component.html',
  styleUrls: ['./property-details.component.css'],
})
export class PropertyDetailsComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public propertyId: number
  private state$: Subscription
  private searchStreetsState$: Subscription
  private searchCommunitiesState$: Subscription
  private streetsAutocomplete$: Subscription
  private communitiesAutocomplete$: Subscription
  public isReadonly: boolean
  public onStreetsAutocomplete$ = new Subject<string>()
  public onCommunitiesAutocomplete$ = new Subject<string>()
  public streets: List<Map<string, any>>
  public communities: List<Map<string, any>>
  private parent: string
  public hasReadonlyPermission: boolean = false
  public wards: Ward[] = []
  public onWardAutocomplete$ = new Subject<string>()
  private wardAutocomplete$: Subscription
  private searchWardsState$: Subscription
  public isWardDetectionLoading$: Observable<boolean>
  private detectWardByCoordinate$: Subscription
  public discountGroups: any[]
  private discountGroupsState$: Subscription
  public assessableTypes = []
  private assessableTypes$: Subscription
  public isLoading: boolean
  public isTranslationActive = false
  public isTranslationActive$: Subscription
  public hasCompoundPermission: boolean
  public licensesModalVisible: boolean = false
  public businesses: any[] = []

  constructor(
    public permissionsService: NgxPermissionsService,
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
  ) {
    super()
  }

  ngOnInit() {
    this.isTranslationActive$ = this.store
      .pipe(select(isContentEditableEnabled))
      .subscribe((isTranslationActive) => {
        this.isTranslationActive = isTranslationActive
      })
    this.store.dispatch<any>(new SetDefaultData('detectWardByCoordinate'))
    this.propertyId = parseInt(this.route.parent.snapshot.params.id, 10)
    this.hasReadonlyPermission =
      this.permissionsService.getPermissions()['READONLY'] !== undefined
    this.hasCompoundPermission =
      this.permissionsService.getPermissions()['COMPOUNDS'] !== undefined
    this.parent = this.propertyId ? 'property' : 'createProperty'
    const getState = this.propertyId ? getPropertyState : getCreatePropertyState
    this.state$ = this.store.pipe(select(getState)).subscribe((state) => {
      this.state = state
      this.isLoading = state.get('isLoading')

      if (this.propertyId) {
        this.isReadonly =
          (this.state.getIn(['data', 'status', 'name']) !== 'DATA_ENTRY' &&
            this.state.getIn(['data', 'status', 'name']) !== 'OBJECTION') ||
          this.hasReadonlyPermission ||
          this.state.getIn(['data', 'status', 'name']) === 'ARCHIVED'

        this.businesses = state.get('businesses')?.toJS() || []

        console.log(this.businesses)
      }
    })

    this.discountGroupsState$ = this.store
      .pipe(select(getDiscountGroupsState))
      .subscribe((discountGroups) => {
        this.discountGroups = discountGroups?.toJS()
      })

    this.assessableTypes$ = this.store
      .pipe(select(getAssessableTypesState))
      .subscribe((assessableTypes) => {
        this.assessableTypes = assessableTypes.toJS()
      })

    this.isWardDetectionLoading$ = this.store.pipe(
      select(isWardDetectionLoading),
    )

    this.searchStreetsState$ = this.store
      .pipe(select(getSearchStreetsState))
      .subscribe((state) => {
        this.streets = state.get('data').toJS()
      })
    this.searchCommunitiesState$ = this.store
      .pipe(select(getSearchCommunitiesState))
      .subscribe((state) => {
        this.communities = state.get('data').toJS()
      })
    this.searchWardsState$ = this.store
      .pipe(select(getSearchWardsState))
      .subscribe((state) => {
        this.wards = state.get('data').toJS()
      })

    this.detectWardByCoordinate$ = this.store
      .pipe(select(getWardDetectionState))
      .subscribe((state) => {
        if (state) {
          this.store.dispatch(
            new UpdateField('ward', state.toJS(), `${this.parent}.data`),
          )
        }
      })

    this.streetsAutocomplete$ = this.onStreetsAutocomplete$
      .pipe(debounceTime(500))
      .subscribe((keyword) => {
        if (keyword) {
          this.store.dispatch<any>(new SearchStreetsRequest(keyword))
        }
      })

    this.communitiesAutocomplete$ = this.onCommunitiesAutocomplete$
      .pipe(debounceTime(500))
      .subscribe((keyword) => {
        if (keyword) {
          this.store.dispatch<any>(new SearchCommunitiesRequest(keyword))
        }
      })

    this.wardAutocomplete$ = this.onWardAutocomplete$
      .pipe(debounceTime(500))
      .subscribe((keyword) => {
        if (keyword) {
          this.store.dispatch<any>(new SearchWardsRequest(keyword))
        }
      })

    this.store.dispatch<any>(new SearchCommunitiesRequest(''))
    this.store.dispatch<any>(new SearchStreetsRequest(''))
    // this.store.dispatch<any>(new SearchWardsRequest(''))
    this.store.dispatch<any>(new FetchDiscountGroupsRequest())
    this.store.dispatch<any>(new FetchAssessableTypesRequest())

    if (!!this.propertyId) {
      this.store.dispatch<any>(
        new FetchPropertyBusinessesRequest(this.propertyId),
      )
    }
  }

  get assessableTypeKeys() {
    return this.assessableTypes.map(({ translationKey }) => translationKey)
  }

  get assessableTypeDefaults() {
    return this.assessableTypes.reduce((prev, current) => {
      return { ...prev, [current.translationKey]: current.title }
    }, {})
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.searchStreetsState$.unsubscribe()
    this.searchCommunitiesState$.unsubscribe()
    this.streetsAutocomplete$.unsubscribe()
    this.communitiesAutocomplete$.unsubscribe()
    this.wardAutocomplete$.unsubscribe()
    this.detectWardByCoordinate$.unsubscribe()
    this.discountGroupsState$.unsubscribe()
    this.assessableTypes$.unsubscribe()
    this.isTranslationActive$.unsubscribe()
  }

  public getDiscountGroups(groups): string {
    if (groups.size === 0) return null

    return groups.map((group: any) => group.get('name')).join(', ')
  }

  public handleFieldChange(
    e: any,
    name: null | string = null,
    path?: any,
  ): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name
          ? e
          : e.target.type === 'checkbox'
          ? e.target.checked
          : e.target.value,
        `${this.parent}.data${path ? `.${path.join('.')}` : ''}`,
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        this.parent,
      ),
    )
  }

  public autoDetect(): void {
    this.store.dispatch<any>(
      new DetectWardByCoordinateRequest([
        this.state.getIn(['data', 'coordinateLat']),
        this.state.getIn(['data', 'coordinateLng']),
      ]),
    )
  }
}
